import {Languages} from '../enums/languages';

export class Constants {
    productionApiURL: string = 'https://gateway.agaia.life/legacy-api';
    productionDataApiURL: string = 'https://gateway.agaia.life/data-api';
    testApiURL: string = 'http://localhost:8000';
    defaultLanguage: Languages = Languages.Bulgarian;
    defaultDateFormat: string = 'dd/MM/yyyy';
    defaultDateTimeFormat: string = 'dd/MM/yyyy HH:mm';
    defaultAPIDateFormat: string = 'yyyy-MM-dd';
    stripePublicKey: string = 'pk_test_N011wmNiUa5o1Fo0BrShYEsM';
    hyperWalletScriptWebsite: string = 'https://sandbox.hyperwallet.com';
    productionImagesUrl: string = 'https://gateway.agaia.life/files-api';

    apiURL() {
        if (window.location.hostname === 'localhost') {
            return this.testApiURL;
        }

        return this.productionApiURL;
    }

    recipeURL() {
        if (window.location.hostname === 'localhost') {
            // return "http://localhost:8080/";
        }

        return this.productionApiURL + '/diary/recipes-new/';
    }

    dataURL() {
        if (window.location.hostname === 'localhost') {
            // return "http://localhost:8080/";
        }

        return this.productionDataApiURL;
    }


    imagesUrl() {
        return this.productionImagesUrl;
    }
}
